export default __webpack_public_path__ + "static/media/awake-prev.52ff2cb5.png";